import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
//import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH, LOGOUT } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import RoleService from "@/core/services/role.service";
import VueSocialSharing from 'vue-social-sharing'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleLeft, faAngleRight, faPlusSquare, faBell, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faDollarSign, faDownload, faEdit, faExchangeAlt, faExternalLinkAlt, faEye, faFile, faFileAlt, faFileInvoice, faFileInvoiceDollar, faHome, faHourglassHalf, faLightbulb, faList, faMap, faMoneyBill, faPenAlt, faPhoneAlt, faQuestion, faSignature, faSignOutAlt, faStar, faTools, faUsers, faBuilding } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
library.add(faExternalLinkAlt, faBuilding, faPlusSquare, faSignOutAlt, faFile, faPenAlt, faMoneyBill, faSignature, faFileInvoiceDollar, faFileInvoice, faExchangeAlt, faTools, faFileAlt, faDollarSign, faChevronLeft, faEye, faBell, faChevronRight, faAngleLeft, faAngleRight, faChevronDown, faChevronUp, faQuestion, faDownload, faEdit, faStar, faList, faHome, faHourglassHalf, faFile, faDollarSign, faMap, faUsers, faPhoneAlt, faFileAlt, faLightbulb)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import VueAos from 'vue-aos'
// Vue 3rd party plugins
import EventBus from './core/plugins/eventBus'
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VueCurrencyFilter from 'vue-currency-filter'
import VueProgressBar from 'vue-progressbar'
import VueTheMask from 'vue-the-mask'
import VueMask from 'v-mask'
import money from 'v-money'
import Multiselect from 'vue-multiselect'
import VueMeta from 'vue-meta'


// API service init
ApiService.init();


// Remove this to disable mock API
//MockService.init();

router.beforeEach((to, from, next) => {

    // Ensure we checked auth before each page load.
    Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

    // reset config to initial state
    store.dispatch(RESET_LAYOUT_CONFIG);

    //chequeamos los permisos del modulo
    const { authorize } = to.meta;

    const currentRole = RoleService.getRole();
    console.log('authorize ' + authorize + ' state ' + currentRole);

    if (authorize) {
        // check if route is restricted by role
        if (authorize.length && !authorize.includes(currentRole)) {
            // role not authorised so redirect to home page
            store.dispatch(LOGOUT);
            //location.href='http://www.bricsa.cl';
            return next({ path: '/login' });
        }
    }

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(200, 0);
    }, 100);
});
Vue.use(Buefy)
Vue.use(EventBus);
Vue.use(VueAos);
Vue.use(VueMask);
Vue.use(VueTheMask)
Vue.use(VueMeta)
Vue.component('multiselect', Multiselect)
Vue.use(VueCurrencyFilter, {
    symbol: '$',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
})
Vue.use(VueSocialSharing);

Vue.filter('uf', function(value) {
    return parseFloat(value).toFixed(2);
});

Vue.filter('number', function(value) {
    return parseFloat(value).toFixed(0);
});


Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '2px'
})
Vue.use(money, {
    decimal: ',',
    thousands: '.',
    prefix: '$ ',
    suffix: '',
    precision: 0,
    masked: false
})

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount("#app");